<template>
  <div>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="600px"
        >
      <div>
        <el-table :data="dataList" v-loading="loading"
                  element-loading-text="加载中……"
                  element-loading-spinner="el-icon-loading" border>
          <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
          <el-table-column label="可查看数据的关联客户" prop="customer_name" align="left"
                           header-align="center"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getKeyCustomerRelCustomers} from "@/api/profileCustomer";

export default {
  name: "DialogScopeCustomer",
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '关联客户',
      loading: false,
      keyCustomerObj: {id: null, title: null, key_customer_id: null},
      // formData: {user_id: null, name: '', scope_all: "N"},
      dataList: [],
    };
  },
  methods: {
    show(keyCustomerObj) {
      this.keyCustomerObj = keyCustomerObj
      this.dialogTitle = `【${this.keyCustomerObj.title}】关联客户`
      this.dialogVisible = true
      this.handleQuery()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          // eslint-disable-next-line no-unused-vars
          .then(_ => {
            done();
          })
          // eslint-disable-next-line no-unused-vars
          .catch(_ => {
          });
    },
    async handleQuery() {
      this.loading = true
      this.dataList = []
      let {data: {list}} = await getKeyCustomerRelCustomers({key_customer_id: this.keyCustomerObj.key_customer_id})
      this.dataList = list || []
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
